module.exports = __webpack_public_path__ + "img/promo-ignis.31cf8aae.jpg";